import React from "react";
import { dealShareStatuses } from "_constants";
import { ShareStatusModal } from "containers/DealDetail/components/DealHeader";
import { Field } from "formik";
import PropTypes from "prop-types";
import { currentUserShape, portfolioShape } from "shapes";

import ShareStatusSelector from "components/ShareStatusSelector";
import {
  allDisabled,
  customDisabled,
  updateShareStatus as newShareStatus,
} from "utils/deals/shareStatus";

const getAssets = (asset, assets) => (asset ? [asset] : assets) || [];

class ShareStatus extends React.Component {
  componentWillUpdate({ currentUser, formik: { values } }) {
    const { asset, assets, portfolio, shareStatus } = values;
    const { values: currentValues } = this.props.formik;

    const nextAssets = getAssets(asset, assets);
    const currentAssets = getAssets(currentValues.asset, currentValues.assets);

    if (currentValues.portfolio !== portfolio || currentAssets.length !== nextAssets.length) {
      this.props.formik.setFieldValue(
        "shareStatus",
        newShareStatus(
          getAssets(asset, assets),
          shareStatus,
          portfolio && currentUser.company.role !== "owner"
        )
      );
    }
  }

  render() {
    const {
      currentUser,
      formik: {
        setFieldValue,
        values: { asset, assets, shareStatus },
      },
      isBroker,
      isShareModalOpen,
      onCloseShareModal,
      onOpenShareModal,
    } = this.props;

    const dealAssets = getAssets(asset, assets);

    return (
      <>
        <Field
          name="shareStatus"
          render={({
            field: { value },
            form: {
              values: { brokers = [] },
            },
          }) => (
            <ShareStatusSelector
              allDisabled={allDisabled(dealAssets)}
              currentStatus={value}
              customDisabled={customDisabled(dealAssets)}
              isBroker={isBroker}
              onSelect={(status) => {
                if (status === "custom") onOpenShareModal();

                return setFieldValue("shareStatus", status);
              }}
              sharedBrokerCount={brokers.length}
              isCreator
              isLarge
            />
          )}
        />
        {shareStatus === "custom" && (
          <Field
            name="_brokers"
            render={({
              field: { value },
              form: {
                values: { portfolio },
              },
            }) => (
              <ShareStatusModal
                assets={dealAssets}
                creator={currentUser}
                isOpen={isShareModalOpen}
                onClose={onCloseShareModal}
                onSave={(sharedBrokers) => {
                  setFieldValue("_brokers", sharedBrokers);
                  onCloseShareModal();
                }}
                portfolioID={portfolio ? portfolio.id : null}
                sharedBrokers={value}
              />
            )}
          />
        )}
      </>
    );
  }
}

ShareStatus.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      asset: PropTypes.object,
      assets: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
        })
      ),
      brokers: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
        })
      ),
      portfolio: PropTypes.shape(portfolioShape),
      shareStatus: PropTypes.oneOf(dealShareStatuses),
    }),
    setFieldValue: PropTypes.func.isRequired,
  }),
  currentUser: PropTypes.shape(currentUserShape),
  onCloseShareModal: PropTypes.func.isRequired,
  onOpenShareModal: PropTypes.func.isRequired,
  isBroker: PropTypes.bool,
  isShareModalOpen: PropTypes.bool,
};

export default ShareStatus;
